export default __webpack_public_path__ + "static/media/Rammy2.31a91f33.jpg";